export default __webpack_public_path__ + "static/media/firebase.a3e64704.gif";